import { render, staticRenderFns } from "./CategoryPill.vue?vue&type=template&id=d96b3256&scoped=true"
import script from "./CategoryPill.vue?vue&type=script&lang=ts"
export * from "./CategoryPill.vue?vue&type=script&lang=ts"
import style0 from "./CategoryPill.vue?vue&type=style&index=0&id=d96b3256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96b3256",
  null
  
)

export default component.exports